import React, { useEffect, useState } from 'react';
import * as d3 from 'd3';
import worldGeoJson from '../utils/customGeoJson.json';
import './css/Visualization1.css';

function Visualization1() {
  const [year, setYear] = useState(2022);

  useEffect(() => {
    // Load CSV data
    d3.csv(`${process.env.PUBLIC_URL}/data/international_tourist_trips_final.csv`).then((loadedData) => {
      const parsedData = loadedData.map(d => ({
        country: d.Entity,
        code: d.Code,
        year: +d.Year,
        trips: +d['Inbound arrivals of tourists'],
      }));

      const yearData = parsedData.filter(d => d.year === year);
      drawMap(yearData);
      createLegend();
    });
  }, [year]);

  const drawMap = (yearData) => {
    // Clear previous SVG
    d3.select("#map").selectAll("*").remove();

    const svgWidth = 800;
    const svgHeight = 550;
    const svg = d3.select("#map")
      .append("svg")
      .attr("width", svgWidth)
      .attr("height", svgHeight);

    const projection = d3.geoMercator()
      .scale(130)
      .translate([svgWidth / 2, svgHeight / 2]);

    const path = d3.geoPath().projection(projection);

    const colorScale = d3.scaleThreshold()
      .domain([500000, 1000000, 5000000, 10000000, 20000000])
      .range(d3.schemeBlues[5]);

    const opacityScale = d3.scaleLinear()
      .domain([0, 20000000])
      .range([0.3, 1]);

    const tooltip = d3.select("body").append("div")
      .attr("class", "tooltip")
      .style("position", "absolute")
      .style("opacity", 0)
      .style("background", "white")
      .style("border", "1px solid black")
      .style("padding", "5px");

    svg.append("g")
      .selectAll("path")
      .data(worldGeoJson.features)
      .enter()
      .append("path")
      .attr("d", path)
      .attr("fill", d => {
        const countryData = yearData.find(country => country.code === d.properties.adm0_a3);
        return countryData ? colorScale(countryData.trips) : "#ccc";
      })
      .style("opacity", d => {
        const countryData = yearData.find(country => country.code === d.properties.adm0_a3);
        return countryData ? opacityScale(countryData.trips) : 0.1;
      })
      .attr("stroke", "#2e2c2c")
      .attr("stroke-width", 0.5)
      .on("mouseover", (event, d) => {
        const countryData = yearData.find(country => country.code === d.properties.adm0_a3);
        tooltip.transition().duration(200).style("opacity", 0.9);
        tooltip.html(`${d.properties.name}: ${countryData ? countryData.trips.toLocaleString() : "No data"} tourists`)
          .style("left", (event.pageX + 5) + "px")
          .style("top", (event.pageY - 28) + "px");
      })
      .on("mouseout", () => {
        tooltip.transition().duration(500).style("opacity", 0);
      });
  };

  const createLegend = () => {
    const legendContainer = d3.select("#legend-container");
    legendContainer.html(""); // Clear previous content

    // "No data" section
    legendContainer.append("div")
      .attr("class", "legend-item")
      .style("display", "inline-block")
      .style("margin-right", "10px")
      .html('<div style="width: 30px; height: 15px; background-color: #fafafa; display: inline-block; border: 1px solid black;"></div> No data');

    // Color scale legend
    const legendData = [500000, 1000000, 5000000, 10000000, 20000000];
    const legendColors = d3.schemeBlues[5];

    legendData.forEach((value, i) => {
      legendContainer.append("div")
        .attr("class", "legend-item")
        .style("display", "inline-block")
        .style("margin-right", "10px")
        .html(`
          <div style="width: 30px; height: 15px; background-color: ${legendColors[i]}; display: inline-block; border: 1px solid black;"></div>
          ${i === legendData.length - 1 ? `${value / 1000000}+ million` : `${value / 1000000} million`}
        `);
    });
  };

  return (
    <div>
      <div className="header-container">
        <h2>
          Choropleth Map of International Tourist Trips
        </h2>
        <p>
          Trips by people who arrive from abroad and stay overnight.
        </p>
      </div>
      <div id="map"></div>
      <div id="legend-container"></div>
      <input
        type="range"
        min="1995"
        max="2022"
        value={year}
        onChange={e => setYear(+e.target.value)}
      />
      <div className="slider-label">{year}</div>
    </div>
  );
}

export default Visualization1;
